import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import util from '@/utils/util'
import NProgress from 'nprogress'
import tools from './tools'
import setting from '@/setting'

Vue.use(VueRouter)

let isAuthorize = setting.isAuthorize
setting.isAuthorize = false
let router = new VueRouter({ routes: tools.routers() })
setting.isAuthorize = isAuthorize

//路由拦截
router.beforeEach(async (to, from, next) => {
  await store.dispatch('user/isLoaded')
  await store.dispatch('tab/isLoaded')
  NProgress.start()
  if (to.query && to.query.token) {
    await store.dispatch('user/set', { token: to.query.token })
    autoLogin(to, next)
  } else {
    if (store.state.user.info.token || (to.meta.disableAuth && to.path !== '/home')) {
      next()
    } else {
      next({
        name: 'login',
        query: { redirect: to.fullPath }
      })
    }
  }
})

//路由拦截
router.afterEach((to, from) => {
  NProgress.done()
  util.title(to.meta.title || process.env.VUE_APP_TITLE)
  store.dispatch('route/setPreviousRoute', from.path)
  store.dispatch('route/setNextRoute', to.path)
})

/**
 * 自动登录
 */
function autoLogin(to, next) {
  store
    .dispatch('account/loginToken')
    .then(() => setTimeout(() => next({ path: to.path }), 500))
    .catch(() => {
      store.dispatch('user/clearUserInfo')
      next({
        name: 'login',
        query: { redirect: to.fullPath }
      })
    })
}

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(err => err)
}

const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(err => err)
}

/**
 * 新增新的router之前重置router
 */
export function resetRouter() {
  const newRouter = new VueRouter()
  router.matcher = newRouter.matcher
}

export default router
